import {
  createConsoleObservability,
  createInstrumentedQueryClient,
  createOtelObservability,
  setActiveObservability,
  type IObservability,
} from '@/observability';

/** Runtime (`__RUNTIME_CONFIG__`) > build (`VITE_*`) > console. */
function createObservabilityFromEnv(): IObservability {
  const runtime = window.__RUNTIME_CONFIG__;
  const mode = (
    runtime?.OBSERVABILITY ||
    import.meta.env.VITE_OBSERVABILITY ||
    'console'
  )
    .toLowerCase()
    .trim();
  if (mode === 'otel') {
    const otlpEndpoint =
      runtime?.OTEL_OTLP_ENDPOINT?.trim() ||
      import.meta.env.VITE_OTEL_OTLP_ENDPOINT?.trim() ||
      undefined;
    return createOtelObservability({ otlpEndpoint });
  }
  return createConsoleObservability();
}

/**
 * Composition root: `console` | `otel` (runtime Docker/Cloud Run ou VITE_* no build).
 * Em otel, OTLP endpoint opcional (sem valor → exporters console do SDK).
 */
export const observability: IObservability = createObservabilityFromEnv();
setActiveObservability(observability);

export const queryClient = createInstrumentedQueryClient(observability);

export function clearQueryCache(): void {
  queryClient.clear();
}
